import React from "react";
import { Dropdown } from "react-bootstrap";
import DropdownButton from "react-bootstrap/esm/DropdownButton";
import MenuSairComponent from "./MenuSairComponent";

const NavigationComponent = (props: any) => {
	const clickMenu = () => {
		if (props.setToggleMenuCollapse != null)
		{
			props.setToggleMenuCollapse();
		}

		let menu = document?.getElementById('main-menu');
		if (menu == null) {
			return;
		}

		document.getElementById('sair-div')?.click();
		if (menu.classList.contains('expanded')) {
			menu.classList.remove('expanded');
			return;
		}

		menu.classList.add('expanded');
	};

	function hideSubMenus(e: any) {
		document.getElementById('main-menu')?.classList.remove('expanded');

		let classMenu = document.getElementsByClassName('menu-principal');
		for (var i = 0; i < classMenu.length; i++) {
			let subMenus = classMenu[i].getElementsByTagName('ul');
			if (subMenus != null) {
				for (var x = 0; x < subMenus.length; x++) {
					subMenus[x].style.display = 'none';
				}
			}

			for (var i = 0; i < classMenu.length; i++) {
				let iconSubMenus = classMenu[i].getElementsByTagName('i');
				if (iconSubMenus == null) {
					continue;
				}

				for (var x = 0; x < iconSubMenus.length; x++) {
					if (iconSubMenus[x].className.indexOf('up-down-arrow') >= 0) {
						iconSubMenus[x].className = 'fa fa-angle-down fa-2x up-down-arrow';
					}
				}
			}
		}
	}

	function getSigla() {
		try {
			if (props.usuario.nome == null) {
				return '';
			}

			return (
				props.usuario.nome.substring(0,1).toUpperCase() +
				props.usuario.sobrenome.substring(0,1).toUpperCase());
			
		} catch (error) {
			return props.usuario.nome;
		}
	}

	return (
		<div className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
			<a className="navbar-brand px-3 fs-6" href="#" onMouseLeave={hideSubMenus}>
				<i onClick={clickMenu} className="fa fa-bars fa-2x"></i>
				{/* <span style={{'backgroundColor': '#fff'}}> */}
				<img src="/Logo_C2_TOWER.svg" width={'200em'} className="logo-main" />
					{/* <img src="/c2_logo_transparent.png" width={'40em'} />
					<span className="font-logo font-logo-1">2</span>
					<span className="font-logo font-logo-2">TOWER</span> */}
				{/* </span> */}
			</a>

			<div className="navbar-nav usuario-style">
				
				<DropdownButton variant="secondary" color="dark" title={getSigla()} id="bg-nested-dropdown">
					<div style={{margin: '0 15px 0 15px', display: 'flex'}}>
						<i className="fa fa-user fa-2x" style={{marginLeft:'-25px', marginRight:'-15px'}}></i>
						<div>{props.usuario?.nome} {props.usuario?.sobrenome} ({props.usuario?.id})</div>
					</div>
					<Dropdown.Item eventKey="1">Trocar senha</Dropdown.Item>
					<Dropdown.Item eventKey="2">
						<MenuSairComponent iconClass="" styleClass="color-black" />
					</Dropdown.Item>
				</DropdownButton>
			</div>
		</div>
	);
}

export default NavigationComponent;